import React from 'react';
import { motion } from 'framer-motion';
import { assets } from '../lib/assets';

export default function CTASection({ onGift }) {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0">
        <img src={assets.handGifting} alt="Hands gifting a tree" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-ink/85 via-brand-ink/65 to-brand-ink/30" />
      </div>
      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
          className="max-w-2xl"
        >
          <div className="flex items-center gap-3 mb-5">
            <div className="h-px w-10 bg-brand-gold" />
            <span className="text-brand-gold text-[11px] tracking-[0.3em] uppercase">Begin</span>
          </div>
          <h2 className="font-serif text-4xl sm:text-6xl lg:text-7xl text-brand-bg leading-[1.05] tracking-tight font-light">
            Plant something that will <em className="text-brand-gold">outlive you.</em>
          </h2>
          <p className="mt-7 text-brand-bg/85 text-lg max-w-xl leading-relaxed">
            A sapling passes from one hand to another — and from a moment, becomes a lifetime.
            Somewhere in Nashik, a patch of soil is already waiting for a name.
          </p>
          <button
            onClick={onGift}
            data-testid="cta-gift-button"
            className="mt-10 rounded-full bg-brand-bg text-brand-ink px-10 py-4 text-base tracking-wide font-medium hover:bg-brand-gold transition-all duration-500 hover:-translate-y-0.5"
          >
            Start Your Tree Today →
          </button>
        </motion.div>
      </div>
    </section>
  );
}
